<template lang="pug">
v-navigation-drawer.toolbar(
  v-model="navDrawerComputed" 
  disable-resize-watcher 
  app 
  clipped 
  :permanent="!isMobile" 
  :mini-variant="getMiniVariant"
) 
  template(#prepend)
    v-container.fill-height.pa-0(v-if="!isMobile" fluid)
      v-row.my-4.mr-4(align="center" no-gutters)
        v-col(cols=3)
          v-btn.ml-2.mr-2(icon large :class="{active: miniVariantNavDrawer}" @click.stop="toggleDrawer")
            v-icon.show-toolbar-icon mdi-chevron-left
        v-slide-x-transition(leave-absolute)
          v-col(v-if="!getMiniVariant" cols=9)
            v-text-field(
              v-model="searchMenuItem"
              clearable
              color="toolbarText"
              placeholder="Buscar"
              outlined
              filled
              full-width
              hide-details
              :dark="isDark"
              :dense="!isMobile"
              type="text"
              @change="searchItemsByText"
              @blur="showAllMenuItems"
            )
              template(#append)
                v-icon(@click="searchItemsByText") mdi-magnify
    v-divider.divider(v-if="!isMobile" dark)
  template(v-if="isMobile")
    v-card.account-card(flat color="primary" height="150px")
      v-container.fill-height(fluid)
        v-card-text.pa-0
          v-menu(v-model="menuValue" left offset-y)
            template(#activator="{on, attrs}" )
              v-btn.action-button(v-bind="attrs" depressed block text height="60px" :class="{active: menuValue}" v-on="on")
                v-row(no-gutters)
                  v-col(cols=6)
                    v-row
                      span.name {{ user.name }}
                    v-row
                      span.group Perfil {{ user.group }}
                  v-col.d-flex.flex-row.justify-end(cols=6)
                    v-icon(color="white") mdi-chevron-down
            v-list
              v-list-item(link :to="{name: 'profile'}")
                v-list-item-icon
                  v-icon mdi-account
                v-list-item-title Visualizar Perfil
              v-list-item(link @click="goToAccountManagement")
                v-list-item-icon
                  v-icon mdi-account-key
                v-list-item-title Gerenciar Conta
              v-list-item(link @click="logout")
                v-list-item-icon
                  v-icon mdi-logout
                v-list-item-title Sair
          TextFieldComponent(
            v-model="searchMenuItem"
            clearable
            label="Buscar"
            dark
            @change="searchItemsByText"
            @blur="showAllMenuItems"
          )
            template(#append)
              v-icon(@click="searchItemsByText") mdi-magnify
    v-divider
  template(v-if="loading")
    v-list
      v-list-item(v-for="(index) in defaultItemsQtd" :key="index")
        v-list-item-content
          v-skeleton-loader(type="list-item-three-line" height="40px" width="200px" max-width="200px" light)
  ToolBarList(v-else :nav-items="menuList" :drawer-status="miniVariantNavDrawer")
</template>

<script>
import ToolBarList from "@/components/toolbar/ToolBarList.vue";
import lodash from "lodash";
import TextFieldComponent from "@/components/inputs/text/TextFieldComponent.vue";
export default {
  name: "ToolBar",
  components: {
    ToolBarList,
    TextFieldComponent,
  },
  props: {
    value: {
      type: Boolean,
      default: () => {},
    },
    navItems: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      navDrawer: true,
      miniVariantNavDrawer: false,
      defaultItemsQtd: 5,
      menuValue: false,
      searchMenuItem: "",
      menuList: [],
      navOpened: true,
    };
  },
  computed: {
    navDrawerComputed: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$emit("input", value);
        }
      },
    },
    getMiniVariant: {
      get() {
        return this.$vuetify.breakpoint.xsOnly
          ? false
          : this.miniVariantNavDrawer;
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isDark() {
      let c = this.$vuetify.theme.themes.light.toolbar.substring(1); // strip #
      let rgb = parseInt(c, 16); // convert rrggbb to decimal
      let r = (rgb >> 16) & 0xff; // extract red
      let g = (rgb >> 8) & 0xff; // extract green
      let b = (rgb >> 0) & 0xff; // extract blue

      let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      if (luma < 80) {
        return true;
      }
      return false;
    },
  },
  watch: {
    navItems: {
      handler() {
        this.menuList = lodash.cloneDeep(this.navItems);
      },
    },
  },
  created() {
    this.menuList = lodash.cloneDeep(this.navItems);
  },
  methods: {
    closeDrawer(value) {
      this.$emit("input", value);
    },
    toggleDrawer() {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.closeDrawer(false);
      } else {
        this.miniVariantNavDrawer = !this.miniVariantNavDrawer;
      }
    },
    logout() {
      this.$emit("logout");
    },
    goToAccountManagement() {
      this.$emit("goToAccountManagement");
    },
    showAllMenuItems() {
      if (!this.searchMenuItem || this.searchMenuItem.trim() === "") {
        this.menuList = lodash.cloneDeep(this.navItems);
      }
    },
    searchItemsByText() {
      if (!this.searchMenuItem || this.searchMenuItem.trim() === "") {
        this.menuList = lodash.cloneDeep(this.navItems);
      } else {
        this.menuList = [];
        let menuCopy = lodash.cloneDeep(this.navItems);

        this.findChildItems(menuCopy, this.searchMenuItem, this.menuList);
      }
    },
    findChildItems(searchArray, textToSearch, destArray) {
      if (!searchArray) return;

      for (let index in searchArray) {
        if (
          !searchArray[index].submenu?.length &&
          searchArray[index]?.title
            .toLowerCase()
            .includes(textToSearch.toLowerCase())
        ) {
          destArray.push(searchArray[index]);
        } else {
          let tempArray = [];
          this.findChildItems(
            searchArray[index].submenu,
            textToSearch,
            tempArray
          );
          if (tempArray.length) {
            searchArray[index].active = true;
            searchArray[index].submenu = tempArray;
            destArray.push(searchArray[index]);
          }
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>

.toolbar
  // background-color: var(--v-toolbar-base) !important
  color: var(--v-toolbar-base) !important
  box-shadow: 5px 0 20px rgba(0,0,0,.25) !important

.v-btn.active .v-icon
  transform: rotate(-180deg)

.name, .group
  font-size: 14px
  font-weight: 500
  color: white

.account-card
  border-radius: 0px !important

.action-button
  border-radius: 0px !important
  text-transform: capitalize

.container
  align-items: center !important
  height: 100px

.show-toolbar-icon, .divider
  fill: var(--v-toolbarText-base) !important
  color: var(--v-toolbarText-base) !important
</style>
